import * as React from 'react';
import { ReactComponent as DoctorIconSVG } from '../../assets/icons/mevo/ic_doctor.svg';
import IconPattern, { IconProps } from './_IconPattern';

const DoctorIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={DoctorIconSVG} variantPlaces={1} baseColor="#ffffff" {...props} />;
};

export default DoctorIcon;
